import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

// Trang admin: khôi phục gia tộc đã xoá.
// Client không tự khôi phục. Trang này mở lại group + thông tin gia tộc, rồi gắn lại
// thành viên cũ chưa thuộc gia tộc khác.
export default class RestoreDeletedFamilyPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            query: '',
            family: null,
            loading: false,
            restoring: false,
        };
    }

    handleQueryChange = (event) => {
        this.setState({ query: event.target.value });
    };

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.lookup();
        }
    };

    lookup = () => {
        const query = this.state.query.trim();
        if (!query) {
            toast.warning('Nhập id hoặc uid phòng gia tộc');
            return;
        }
        this.setState({ loading: true, family: null });
        axios.post(global.config.apiDomain + '/mc-live-room/web/deleted-families/lookup', { query })
            .then((res) => {
                this.setState({ loading: false });
                if (res.data && res.data.status === 'OK') {
                    this.setState({ family: res.data.data });
                } else {
                    toast.error(res.data?.message || 'Không tìm thấy gia tộc đã xoá');
                }
            })
            .catch(() => {
                this.setState({ loading: false });
                toast.error('Có lỗi khi tìm gia tộc');
            });
    };

    restore = () => {
        const family = this.state.family;
        if (!family) return;
        if (!window.confirm('Khôi phục gia tộc "' + (family.name || family.roomId) + '" và các thành viên chưa có gia tộc mới?')) {
            return;
        }
        this.setState({ restoring: true });
        axios.post(global.config.apiDomain + '/mc-live-room/web/deleted-families/restore', { roomId: family.roomId })
            .then((res) => {
                this.setState({ restoring: false });
                if (res.data && res.data.status === 'OK') {
                    const data = res.data.data || {};
                    toast.success('Đã khôi phục ' + (data.restoredCount || 0) + ' thành viên. Bỏ qua ' + (data.skippedCount || 0) + ' người đã có gia tộc mới.');
                    this.setState({ family: data });
                } else {
                    toast.error(res.data?.message || 'Khôi phục thất bại');
                }
            })
            .catch(() => {
                this.setState({ restoring: false });
                toast.error('Có lỗi khi khôi phục gia tộc');
            });
    };

    render() {
        const { query, family, loading, restoring } = this.state;
        const members = family?.members || [];
        const canRestoreCount = members.filter((member) => member.canRestore).length;
        return (
            <div className="container-fluid" style={{ marginTop: '100px', marginBottom: '40px' }}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header bg-primary text-white">
                                <h3 className="card-title mb-0">
                                    <i className="fa-solid fa-users mr-2"></i>
                                    Khôi phục gia tộc
                                </h3>
                            </div>
                            <div className="card-body">
                                <p className="text-muted">
                                    Nhập id hoặc uid phòng gia tộc đã xoá. Khôi phục thông tin group và gia tộc, rồi gắn lại thành viên cũ chưa vào gia tộc mới.
                                </p>
                                <div className="row align-items-end">
                                    <div className="col-md-8">
                                        <div className="form-group">
                                            <label htmlFor="family-query"><strong>Id hoặc uid phòng</strong></label>
                                            <input
                                                id="family-query"
                                                className="form-control"
                                                placeholder="Id hoặc uid phòng"
                                                value={query}
                                                onChange={this.handleQueryChange}
                                                onKeyPress={this.handleKeyPress}
                                                disabled={loading || restoring}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label>&nbsp;</label>
                                            <button className="btn btn-primary btn-block" onClick={this.lookup} disabled={loading || restoring}>
                                                {loading ? 'Đang tìm...' : 'Tìm'}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {family && (
                                    <div className="mt-2">
                                        <h5 className="mb-2">{family.name || '(không tên)'}</h5>
                                        <div>Phòng #{family.roomId} · uid {family.uid || '—'}</div>
                                        <div>Gia tộc #{family.familyId || '—'} · {family.familyName || family.name}</div>
                                        <div>Mô tả: {family.groupDescription || family.description || '—'}</div>
                                        <div className="mt-3 mb-3">
                                            <button className="btn btn-success" onClick={this.restore} disabled={restoring}>
                                                {restoring ? 'Đang khôi phục...' : 'Khôi phục gia tộc'}
                                            </button>
                                            <span className="ml-3 text-muted">
                                                Khôi phục được: {canRestoreCount}
                                                {' · '}Bỏ qua: {members.length - canRestoreCount}
                                            </span>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table table-sm table-bordered mb-0">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th>User</th>
                                                        <th>Tên</th>
                                                        <th>Vai trò</th>
                                                        <th>Trạng thái</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {members.length === 0 && (
                                                        <tr><td colSpan="4">Không còn snapshot thành viên.</td></tr>
                                                    )}
                                                    {members.map((member) => (
                                                        <tr key={member.userId}>
                                                            <td>{member.userId}</td>
                                                            <td>{member.name || '—'}</td>
                                                            <td>{member.role}</td>
                                                            <td>{member.reason}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
